import PageCommon from "../PageCommon.js";

export default class DragControl extends PageCommon {
	constructor(container, item, callback) {
		super();

		this.container = document.querySelector(container);
		this.dragItem = document.querySelector(item);

		this.active = false;
		this.currentX;
		this.currentY;
		this.initialX;
		this.initialY;
		this.xOffset = 0;
		this.yOffset = 0;

		this.callback = callback;

		this.disabled = false;
	}
	init($data) {
		super.init($data);

		if (window.innerWidth > this.maxWidthMobile) {
			this.container.addEventListener("touchstart", this.dragStart.bind(this), false);
			this.container.addEventListener("touchend", this.dragEnd.bind(this), false);
			this.container.addEventListener("touchmove", this.drag.bind(this), false);

			this.container.addEventListener("mousedown", this.dragStart.bind(this), false);
			this.container.addEventListener("mouseup", this.dragEnd.bind(this), false);
			this.container.addEventListener("mousemove", this.drag.bind(this), false);

			this.dragItem.addEventListener("reset", this.reset.bind(this), false);
		}
	}

	disposeEvents() {
		this.container.removeEventListener("touchstart", this.dragStart.bind(this), false);
		this.container.removeEventListener("touchend", this.dragEnd.bind(this), false);
		this.container.removeEventListener("touchmove", this.drag.bind(this), false);

		this.container.removeEventListener("mousedown", this.dragStart.bind(this), false);
		this.container.removeEventListener("mouseup", this.dragEnd.bind(this), false);
		this.container.removeEventListener("mousemove", this.drag.bind(this), false);

		this.dragItem.removeEventListener("reset", this.reset.bind(this), false);
	}

	dragStart(e) {
		e.preventDefault();
		if (this.disabled) {
			return;
		}
		if (e.type === "touchstart") {
			this.initialY = e.touches[0].clientY - this.yOffset;
		} else {
			this.initialY = e.clientY - this.yOffset;
		}

		if (e.target === this.dragItem) {
			this.active = true;
		}
	}

	dragEnd(e) {
		this.initialY = 0;
		this.yOffset = 0;

		this.active = false;
	}

	drag(e) {
		if (this.active) {
			e.preventDefault();
			if (e.type === "touchmove") {
				this.currentY = e.touches[0].clientY - this.initialY;
			} else {
				this.currentY = e.clientY - this.initialY;
			}

			if (this.currentY < -10) {
				this.dragEnd(e);
				this.reset();
				return;
			}
			if (this.currentY > 0) {
				return;
			}

			this.yOffset = this.currentY;

			this.dragItem.style.transform = "translate3d(-50%, " + this.currentY + "px, 0)";
		}
	}

	reset() {
		// console.log("RESET DRAG");
		this.disposeEvents();
		this.disabled = true;
		this.callback();
	}
}
